<template>
  <div
    v-if="author || reviewer || shouldRenderPublishedRow || shouldRenderUpdatedRow"
    class="byline"
  >
    <span
      v-if="author"
      class="byline__item"
    >
      <span class="byline__label">By</span>
      <span class="byline__value">{{ author.title }}</span>
    </span>

    <span
      v-if="reviewer"
      class="byline__item"
    >
      <span class="byline__label">Reviewed by</span>
      <span class="byline__value">{{ reviewer.title }}</span>
    </span>

    <span
      v-if="shouldRenderPublishedRow"
      class="byline__item"
    >
      <span class="byline__label">Published</span>
      <time :datetime="publishedDate" class="byline__value">{{ formatDate(publishedDate) }}</time>
    </span>

    <span
      v-if="shouldRenderUpdatedRow"
      class="byline__item"
    >
      <span class="byline__label">Updated</span>
      <time :datetime="updatedDate" class="byline__value">{{ formatDate(updatedDate) }}</time>
    </span>
  </div>
</template>

<script setup>
const props = defineProps({
  author: {
    type: Object,
    default: null
  },
  reviewer: {
    type: Object,
    default: null
  },
  publishedDate: {
    type: String,
    default: null
  },
  updatedDate: {
    type: String,
    default: null
  },
  showPublishedDate: {
    type: Boolean,
    default: true
  }
})

const sameDay = (a, b) => {
  if (!a || !b) return false
  const da = new Date(a)
  const db = new Date(b)
  if (Number.isNaN(da.getTime()) || Number.isNaN(db.getTime())) return false
  return da.toDateString() === db.toDateString()
}

const updatedDifferentFromPublished = computed(() => {
  if (!props.updatedDate) return false
  if (!props.publishedDate) return true
  return !sameDay(props.updatedDate, props.publishedDate)
})

const shouldRenderPublishedRow = computed(() =>
  props.showPublishedDate && !!props.publishedDate
)

const shouldRenderUpdatedRow = computed(() => updatedDifferentFromPublished.value)

const formatDate = iso => {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleDateString('en-AU', { year: 'numeric', month: 'long', day: 'numeric' })
}
</script>

<style scoped>
.byline {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0 0.5rem;
  max-width: 42rem;
  margin: 1rem 0 2rem;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid #e8e6df;
  font-size: 0.8125rem;
  line-height: 1.7;
  color: #6b6b6b;
}

.byline__item {
  display: inline-flex;
  align-items: baseline;
  gap: 0.3rem;
}

.byline__item + .byline__item::before {
  content: '·';
  margin-right: 0.35rem;
  color: #c0beb5;
}

.byline__label {
  color: #9a988f;
}

.byline__value {
  color: #3d3d3d;
}

.byline time.byline__value {
  color: #3d3d3d;
}
</style>
